import {KeyboardDateTimePicker} from "@material-ui/pickers";
import styled from "styled-components";
import React from "react";

const DateTimeInput = (props) => {
    const pickerEditorProps = field => ({
        className: "input",
        ampm: false,
        value: props.value,
        onChange: props.onChange,
        id: 'dateInput',
        inputVariant: 'outlined',
        format: 'DD/MM/YYYY HH:mm',
        invalidDateMessage: '',
        onError: () => null
    })
    return (
        <StyledDateInput className={props.className}>
            <label htmlFor="dateInput">{props.label}</label>
            <KeyboardDateTimePicker  {...pickerEditorProps()} />
        </StyledDateInput>)
}

const StyledDateInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;  
  label {
    font-size: 16px;
    margin-bottom: 5px;
  }

  .input {
    width: 100%;
    background: white;
    border: 1px solid #BCE0FD;
    border-radius: 5px;

    * {
      border: none;
      outline: none;
    }

  }
`
export default DateTimeInput